import { Link } from "react-scroll";
import { RENTAL_CATEGORIES, SCROLL_LINK_PROPS } from "../rentalsDisplayConfig";
import Button from "components/Button/Button";

const RentalCategoryNav = ({ rentals, getPropertyConfig }) => {
  const resolveDisplayName = (propertyId) => {
    const propertyConfig = getPropertyConfig(propertyId);
    const rental = rentals.find((r) => r.id === propertyId);
    return propertyConfig?.displayName || rental?.title || propertyId;
  };

  return (
    <div className="possible-rentals">
      {RENTAL_CATEGORIES.map((category) => (
        <div key={category.id}>
          <h2 className="display-font">{category.title}</h2>
          <p>{category.description}</p>
          <ul>
            {category.propertyIds.map((propertyId) => (
              <Link
                className="link-to-property"
                key={propertyId}
                to={propertyId}
                {...SCROLL_LINK_PROPS}
              >
                <li>{resolveDisplayName(propertyId)} <span>&#8594;</span></li>
              </Link>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RentalCategoryNav;
